export default __webpack_public_path__ + "static/pulkit-narwani-3830e93fd6949e501448dfcab8bfdac6.jpg";